import React from 'react';
import { Phone, MapPin, Clock, Star, ShoppingBag } from 'lucide-react';
import { Button } from './ui/button';
import { LINKS } from '../config/links';

const HeroSection = () => {
  const handleNavClick = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({ top: elementPosition - offset, behavior: 'smooth' });
    }
  };

  return (
    <section
      id="accueil"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1513104890138-7c749659a591?w=1920&q=80"
          alt="Pizza artisanale"
          className="w-full h-full object-cover"
        />
        {/* Overlay sombre pour lisibilité du texte */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/80" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2 mb-6 animate-fade-in">
          <div className="flex items-center">
            {[...Array(5)].map((_, i) => (
              <Star
                key={i}
                className={`w-4 h-4 ${i < 4 ? 'text-amber-400 fill-amber-400' : 'text-amber-400/50 fill-amber-400/50'}`}
              />
            ))}
          </div>
          <span className="text-white/90 text-sm font-medium">
            4.8/5 sur Google
          </span>
        </div>

        {/* Title */}
        <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-4 tracking-tight">
          <span className="block">Le Paradis</span>
          <span className="block text-amber-400 text-3xl sm:text-4xl lg:text-5xl font-light mt-2">
            Pizzeria Artisanale à Bondy
          </span>
        </h1>

        {/* Subtitle */}
        <p className="text-lg sm:text-xl text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          Savourez l'authenticité de nos pizzas préparées avec passion,
          nos burgers gourmands et nos plats méditerranéens.
        </p>

        {/* Info Pills */}
        <div className="flex flex-wrap justify-center gap-4 mb-10">
          <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2">
            <Clock className="w-4 h-4 text-amber-400" />
            <span className="text-white/90 text-sm">Ouvert jusqu'à 23:30</span>
          </div>
          <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2">
            <MapPin className="w-4 h-4 text-amber-400" />
            <span className="text-white/90 text-sm">Bondy (93)</span>
          </div>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          {/* Bouton principal Uber Eats */}
          <a
            href={LINKS.uberEats}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button
              size="lg"
              className="bg-amber-600 hover:bg-amber-700 text-white px-8 py-6 text-lg font-semibold shadow-2xl hover:shadow-amber-500/25 transition-all duration-300 hover:-translate-y-1 w-full sm:w-auto"
            >
              <ShoppingBag className="w-5 h-5 mr-2" />
              Commander sur Uber Eats
            </Button>
          </a>
          
          {LINKS.phone && (
            <a href={`tel:${LINKS.phone}`}>
              <Button
                size="lg"
                variant="outline"
                className="border-2 border-white/30 bg-white/10 backdrop-blur-sm text-white hover:bg-white/20 hover:border-white/50 px-8 py-6 text-lg font-semibold transition-all duration-300 w-full sm:w-auto"
              >
                <Phone className="w-5 h-5 mr-2" />
                Appeler
              </Button>
            </a>
          )}
          
          {LINKS.directions && (
            <a
              href={LINKS.directions}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button
                size="lg"
                variant="outline"
                className="border-2 border-white/30 bg-white/10 backdrop-blur-sm text-white hover:bg-white/20 hover:border-white/50 px-8 py-6 text-lg font-semibold transition-all duration-300 w-full sm:w-auto"
              >
                <MapPin className="w-5 h-5 mr-2" />
                Itinéraire
              </Button>
            </a>
          )}
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center pt-2">
          <div className="w-1 h-3 bg-white/60 rounded-full animate-scroll" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
